/* Zahrella Tracking-Seite: Sendungsverlauf aufräumen (Stand 28.10.2026)
   Läuft nur auf /apps/parcelpanel. ParcelPanel zeigt jeden Eintrag als
   "Beschreibung, Details", OMGO schreibt in beide Felder denselben Text,
   daher die Doppelung. Das Skript
   1. entfernt die Doppelung,
   2. übersetzt die bekannten Einträge in die Sprache der Seite,
   3. ersetzt alles, was nach Ausland aussieht (Zoll, Flughafen, Airline,
      chinesische Zeichen), durch neutrale Texte,
   4. stellt Datum und Uhrzeit auf das Format der Seitensprache um
      ("Okt 27, 2026 07:33 am" -> "27.10.2026, 07:33"),
   5. fasst gleiche Einträge direkt untereinander zusammen (der älteste bleibt).
   Unbekannte Einträge bleiben, wie sie sind (nur ohne Doppelung). */
(function () {
  if (location.pathname.indexOf('/apps/parcelpanel') === -1) return;

  var LANG = (document.documentElement.lang || 'de').slice(0, 2).toLowerCase();

  var TEXT = {
    INFO:          { de: 'Sendungsdaten erhalten', it: 'Dati della spedizione ricevuti', fr: 'Informations sur le colis reçues', nl: 'Zendinggegevens ontvangen', en: 'Shipment information received' },
    DATA_DHL:      { de: 'Die Sendungsdaten wurden elektronisch an DHL übermittelt', it: 'I dati della spedizione sono stati trasmessi elettronicamente a DHL', fr: 'Les données du colis ont été transmises électroniquement à DHL', nl: 'De zendinggegevens zijn elektronisch aan DHL doorgegeven', en: 'Shipment data has been sent to DHL electronically' },
    PICKED:        { de: 'Sendung abgeholt', it: 'Spedizione ritirata', fr: 'Colis pris en charge', nl: 'Zending opgehaald', en: 'Shipment picked up' },
    AT_FACILITY:   { de: 'Sendung im Versandzentrum eingetroffen', it: 'Spedizione arrivata al centro di spedizione', fr: "Colis arrivé au centre d'expédition", nl: 'Zending aangekomen in het verzendcentrum', en: 'Shipment arrived at the shipping center' },
    LEFT_FACILITY: { de: 'Sendung hat das Versandzentrum verlassen', it: 'La spedizione ha lasciato il centro di spedizione', fr: "Le colis a quitté le centre d'expédition", nl: 'Zending heeft het verzendcentrum verlaten', en: 'Shipment left the shipping center' },
    TO_DHL:        { de: 'Sendung ist auf dem Weg zu DHL', it: 'Spedizione in viaggio verso DHL', fr: 'Colis en route vers DHL', nl: 'Zending is onderweg naar DHL', en: 'Shipment on its way to DHL' },
    HANDOVER:      { de: 'Sendung an den Transportdienstleister übergeben', it: 'Spedizione affidata al vettore', fr: 'Colis remis au transporteur', nl: 'Zending overgedragen aan de vervoerder', en: 'Shipment handed over to the carrier' },
    IN_TRANSIT:    { de: 'Sendung ist unterwegs', it: 'Spedizione in transito', fr: 'Colis en cours d’acheminement', nl: 'Zending is onderweg', en: 'Shipment on its way' },
    ARRIVED_HUB:   { de: 'Sendung im Verteilzentrum eingetroffen', it: 'Spedizione arrivata al centro di distribuzione', fr: 'Colis arrivé au centre de distribution', nl: 'Zending aangekomen in het distributiecentrum', en: 'Shipment arrived at the distribution center' },
    PREPARING:     { de: 'Sendung wird für die Zustellung vorbereitet', it: 'La spedizione è in preparazione per la consegna', fr: 'Le colis est en préparation pour la livraison', nl: 'Zending wordt voorbereid voor bezorging', en: 'Shipment is being prepared for delivery' },
    PROCESSING:    { de: 'Sendung in Bearbeitung', it: 'Spedizione in lavorazione', fr: 'Colis en cours de traitement', nl: 'Zending wordt verwerkt', en: 'Shipment is being processed' },
    SORTED:        { de: 'Sendung im Paketzentrum bearbeitet', it: 'Spedizione lavorata nel centro di smistamento', fr: 'Colis traité au centre de tri', nl: 'Zending verwerkt in het sorteercentrum', en: 'Shipment processed at the sorting center' },
    OUT:           { de: 'Sendung ist in Zustellung', it: 'Spedizione in consegna', fr: 'Colis en cours de livraison', nl: 'Zending wordt bezorgd', en: 'Out for delivery' },
    DELIVERED:     { de: 'Sendung wurde zugestellt', it: 'Spedizione consegnata', fr: 'Colis livré', nl: 'Zending bezorgd', en: 'Delivered' },
    ATTEMPT:       { de: 'Zustellversuch nicht erfolgreich', it: 'Tentativo di consegna non riuscito', fr: 'Tentative de livraison infructueuse', nl: 'Bezorgpoging mislukt', en: 'Delivery attempt unsuccessful' },
    PICKUP_READY:  { de: 'Sendung liegt zur Abholung bereit', it: 'Spedizione pronta per il ritiro', fr: 'Colis disponible au point de retrait', nl: 'Zending ligt klaar om op te halen', en: 'Ready for pickup' }
  };

  // Bekannte OMGO-Texte, klein geschrieben, ohne Punkt am Ende
  var EXACT = {
    'parcel information received': 'INFO',
    'the instruction data for this shipment have been provided by the sender to dhl electronically': 'DATA_DHL',
    'shipment picked up': 'PICKED',
    'shipment arrived at facility and measured': 'AT_FACILITY',
    'depart from facility to service provider': 'LEFT_FACILITY',
    'the shipment is in transit to dhl': 'TO_DHL',
    'hand over to airline': 'HANDOVER',
    'departure from the original airport': 'IN_TRANSIT',
    'arrival to the destination airport': 'ARRIVED_HUB',
    'released from customs: customs cleared': 'PREPARING'
  };

  var CJK = /[　-〿㐀-鿿豈-﫿]/;
  var CUSTOMS = /custom|clearance|duty|dutie|tax|import|export|zoll|verzoll|douane|dogan|douan/i;
  var AIR = /airline|airport|airway|flight|aircraft|air ?freight|plane|flughafen|fluggesellschaft|flug|aeroport|aéroport|aereo|luchthaven|vlucht/i;
  var ABROAD = /origin country|country of origin|destination country|transit country|international|overseas|abroad|ausland|herkunftsland|zielland|zielgebiet/i;
  var ARRIVAL = /arriv|landed|ankunft|eingetroffen|angekommen|aankomst|arrivé/i;

  function norm(s) {
    return s.replace(/\s+/g, ' ').trim().replace(/[.\s]+$/, '').toLowerCase();
  }

  function out(key) {
    var t = TEXT[key];
    return t[LANG] || t.en;
  }

  function sensitive(s) {
    return CJK.test(s) || CUSTOMS.test(s) || AIR.test(s) || ABROAD.test(s);
  }

  // "X, X" -> "X"
  function dedupe(s) {
    var i = s.indexOf(', ');
    while (i !== -1) {
      var a = s.slice(0, i), b = s.slice(i + 2);
      if (norm(a) === norm(b)) return a.trim();
      i = s.indexOf(', ', i + 1);
    }
    return s.trim();
  }

  function byCategory(s) {
    if (CJK.test(s)) return 'PROCESSING';
    if (CUSTOMS.test(s)) return 'PREPARING';
    if (AIR.test(s) || ABROAD.test(s)) return ARRIVAL.test(s) ? 'ARRIVED_HUB' : 'IN_TRANSIT';
    var n = norm(s);
    if (/could not be delivered|not delivered|unsuccessful|delivery attempt|failed attempt/.test(n)) return 'ATTEMPT';
    if (/ready for pick ?up|pick ?up point|parcelshop|parcel shop|packstation|post office/.test(n)) return 'PICKUP_READY';
    if (/out for delivery|delivery vehicle|on (its|the) way to the recipient/.test(n)) return 'OUT';
    if (/successfully delivered|has been delivered|^delivered/.test(n)) return 'DELIVERED';
    if (/parcel cent(er|re)|sorting|sorted|processed/.test(n)) return 'SORTED';
    return null;
  }

  function clean(raw) {
    var s = dedupe(raw);
    var key = EXACT[norm(s)];
    if (key) return out(key);

    // "Text, Ort": Text übersetzen, Ort nur behalten, wenn er unverfänglich ist
    var i = s.indexOf(', ');
    if (i !== -1) {
      var head = s.slice(0, i), tail = s.slice(i + 2).trim();
      key = EXACT[norm(head)];
      if (key) return out(key) + (tail && !sensitive(tail) ? ', ' + tail : '');
    }

    key = byCategory(s);
    return key ? out(key) : s;
  }

  // Datum: "Okt 27, 2026 07:33 am" -> "27.10.2026, 07:33", "Okt 12" -> "12.10."
  var MONTHS = {
    jan: 1, janv: 1, gen: 1, feb: 2, 'fév': 2, 'févr': 2, mar: 3, mars: 3, 'mär': 3, mrt: 3,
    apr: 4, avr: 4, may: 5, mai: 5, mag: 5, mei: 5, jun: 6, juin: 6, giu: 6,
    jul: 7, juil: 7, lug: 7, aug: 8, 'aoû': 8, 'août': 8, ago: 8,
    sep: 9, sept: 9, set: 9, oct: 10, okt: 10, ott: 10, nov: 11, dec: 12, 'déc': 12, dez: 12, dic: 12
  };
  var FULL = /^([^\s\d,]+)\.?\s+(\d{1,2}),?\s+(\d{4}),?\s+(\d{1,2}):(\d{2})(?:\s*([ap])\.?\s?m\.?)?$/i;
  var SHORT = /^([^\s\d,]+)\.?\s+(\d{1,2})$/;
  var SEP = { de: '.', nl: '-' };

  function month(token) {
    var t = token.toLowerCase().replace(/\./g, '');
    return MONTHS[t] || MONTHS[t.slice(0, 4)] || MONTHS[t.slice(0, 3)] || 0;
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function formatDate(s) {
    var sep = SEP[LANG] || '/', m, mo;
    if ((m = FULL.exec(s)) && (mo = month(m[1]))) {
      var h = +m[4];
      if (m[6]) {
        var pm = m[6].toLowerCase() === 'p';
        if (h === 12) h = pm ? 12 : 0; else if (pm) h += 12;
      }
      return pad(+m[2]) + sep + pad(mo) + sep + m[3] + ', ' + pad(h) + ':' + m[5];
    }
    if ((m = SHORT.exec(s)) && (mo = month(m[1]))) {
      return pad(+m[2]) + sep + pad(mo) + (sep === '.' ? '.' : '');
    }
    return null;
  }

  function fixDates(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node, nodes = [];
    while ((node = walker.nextNode())) nodes.push(node);
    for (var i = 0; i < nodes.length; i++) {
      var raw = nodes[i].nodeValue, text = raw.trim();
      if (!text || text.length > 40) continue;
      var result = formatDate(text);
      if (result) nodes[i].nodeValue = raw.replace(text, result);
    }
  }

  function run(root) {
    var spans = root.querySelectorAll('.timeline-item__content span');
    for (var i = 0; i < spans.length; i++) {
      var el = spans[i];
      var text = el.textContent;
      if (!text || text === el.getAttribute('data-zh-out')) continue;
      var result = clean(text);
      el.setAttribute('data-zh-out', result);
      if (result !== text) el.textContent = result;
    }
    collapse(root);
    fixDates(root);
  }

  // Gleiche Einträge direkt untereinander: nur den ältesten (untersten) zeigen
  function collapse(root) {
    var items = root.querySelectorAll('.timeline-item');
    for (var i = 0; i < items.length; i++) {
      var cur = items[i].querySelector('.timeline-item__content span');
      var older = items[i + 1] && items[i + 1].querySelector('.timeline-item__content span');
      var dup = cur && older && norm(cur.textContent) === norm(older.textContent);
      if (dup) items[i].style.display = 'none';
      else if (items[i].style.display === 'none') items[i].style.display = '';
    }
  }

  function start() {
    var root = document.getElementById('pp-tracking-page-app') || document.body;
    run(root);
    new MutationObserver(function () { run(root); })
      .observe(root, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
